import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/yys.css';

function Eventbanner() {
    return (
        <div id='eventbanner'>
            <div className="d-none d-lg-flex  ">
                <a href="#none" className=' ms-auto me-auto'><img src="/img/img_yys/png/eventbanner.png" alt="어글리어스 공식어플 출시!" /></a>
            </div>
        </div>
    )
}

export default Eventbanner
  